import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'tv-customer-photo-dialog',
  templateUrl: 'customer.photo.dialog.component.html',
  styles: [`.button-align {text-align: right} .photo-size { width: 315px; height: 315px }`]
})
export class CustomerPhotoDialogComponent {
  title: string;
  imageContent: string;
  description: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CustomerPhotoDialogComponent>) {
    if (data) {
      this.imageContent = data.imageContent;
      this.description = data.description;
    }
    this.title = this.description ;
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

}
